<div class="pod-section" [formGroup]="form" *ngIf="isVisible">

  <h2 class="pod-section__title">{{ sectionLabel }}</h2>

  <div class="pod-grid">

    <div class="pod-field pod-field--full">
      <div class="pod-file-error" *ngIf="bannerMessage">
        <span class="one-icon-warning-outline"></span>
        {{ bannerMessage }}
      </div>
      <ng-container *ngIf="!uploadedFileName && !viewMode; else filePreview">
        <div class="pod-file-zone"
          [class.file-required]="hasFileError"
          (dragover)="$event.preventDefault()"
          (drop)="onFileDrop($event)">
          <input
            type="file"
            accept="application/pdf"
            class="pod-file-zone__input"
            #fileInput
            (change)="onFileChange($event)"
          />
          <svg class="pod-file-zone__illustration" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="60" cy="60" r="55" stroke="#D0D5DD" stroke-width="1.5"/>
            <rect x="38" y="32" width="36" height="44" rx="3" stroke="#BCC0C8" stroke-width="1.5"/>
            <path d="M62 32v12h12" stroke="#BCC0C8" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M60 72V52M53 59l7-7 7 7" stroke="#BCC0C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="pod-file-zone__text">Drag and drop files here or</span>
          <button type="button" class="pod-file-zone__browse" (click)="fileInput.click()">
            Browse file
          </button>
        </div>
      </ng-container>
      <ng-template #filePreview>
        <div class="pod-file-card" [class.pod-file-card--uploading]="uploading" [class.pod-file-card--error]="fileErrorType === ERROR_TYPE.UPLOAD_FAILED">
          <div class="pod-file-card__icon-wrap">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M21 3H9a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V12L21 3z" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 3v9h9" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <text x="9" y="27" font-size="8" fill="#4589ff" font-family="sans-serif" font-weight="700" letter-spacing="0.5">PDF</text>
            </svg>
          </div>
          <span class="pod-file-card__name" [title]="uploadedFileName">{{ uploadedFileName }}</span>
          <span *ngIf="uploading" class="pod-file-card__status">Uploading…</span>
          <span *ngIf="fileErrorType === ERROR_TYPE.UPLOAD_FAILED" class="pod-file-card__status pod-file-card__status--error">Upload failed</span>
          <div class="pod-file-card__actions" *ngIf="!uploading && fileErrorType !== ERROR_TYPE.UPLOAD_FAILED">
            <button type="button" class="pod-file-card__btn pod-file-card__btn--remove" (click)="removeFile()" *ngIf="!viewMode">
              Remove
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M10.5 3.5l-7 7M3.5 3.5l7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
            <button type="button" class="pod-file-card__btn pod-file-card__btn--download" (click)="downloadFile()" *ngIf="viewMode" [disabled]="isDownloading">
              Download
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M7 1v8M3.5 6.5L7 10l3.5-3.5M1.5 12.5h11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button type="button" class="pod-file-card__btn pod-file-card__btn--preview" (click)="openPreview()" [disabled]="isPreviewing">
              Preview
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <ellipse cx="7" cy="7" rx="6" ry="4" stroke="currentColor" stroke-width="1.4"/>
                <circle cx="7" cy="7" r="1.8" fill="currentColor"/>
              </svg>
            </button>
          </div>
        </div>
      </ng-template>
    </div>

  </div>
</div>
